const InformationCircleIcon = ({ className, fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.66036 7.83416C7.61406 7.83341 7.56052 7.83339 7.49447 7.83339C7.21832 7.83339 6.99447 7.60953 6.99447 7.33339C6.99447 7.05724 7.21832 6.83339 7.49447 6.83339L7.51743 6.83338C7.65417 6.83333 7.80204 6.83327 7.92685 6.85005C8.07306 6.86971 8.25986 6.92026 8.41706 7.07746C8.57425 7.23466 8.62481 7.42146 8.64447 7.56767C8.66125 7.69248 8.66119 7.84035 8.66114 7.97709L8.66113 11.3334C8.66113 11.6095 8.43727 11.8334 8.16113 11.8334C7.88499 11.8334 7.66113 11.6095 7.66113 11.3334V8.00005C7.66113 7.934 7.66111 7.88046 7.66036 7.83416Z"
        fill={fill || "#232233"}
      />
      <path
        d="M7.99447 4.66671C7.62628 4.66671 7.3278 4.96518 7.3278 5.33337C7.3278 5.70156 7.62628 6.00004 7.99447 6.00004H8.00045C8.36864 6.00004 8.66712 5.70156 8.66712 5.33337C8.66712 4.96518 8.36864 4.66671 8.00045 4.66671H7.99447Z"
        fill={fill || "#232233"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.833008 8.00004C0.833008 11.9581 4.04163 15.1667 7.99967 15.1667C11.9577 15.1667 15.1663 11.9581 15.1663 8.00004C15.1663 4.042 11.9577 0.833374 7.99967 0.833374C4.04163 0.833374 0.833008 4.042 0.833008 8.00004ZM7.99967 14.1667C4.59392 14.1667 1.83301 11.4058 1.83301 8.00004C1.83301 4.59428 4.59392 1.83337 7.99967 1.83337C11.4054 1.83337 14.1663 4.59428 14.1663 8.00004C14.1663 11.4058 11.4054 14.1667 7.99967 14.1667Z"
        fill={fill || "#232233"}
      />
    </svg>
  );
};

export default InformationCircleIcon;
